import { useEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import CommonUtil from "../../../common/commonUtil";
import { getCourseInfo, getYoyakuKanoTimeInfo, setReserve } from "../../../const";
import MessageConst from "../../../const/messageConst";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { ModalClose } from "../../atoms/modalClose";
import { ErrorMassage } from "../../molecules/errorMassage";
import { PullDownOptionForm } from "../../molecules/pullDownOptionForm";
import { RadioButtonForm } from "../../molecules/radioButtonForm";


const EstheticUserPopupContainer = (props) => {
    const {
        login,
        state,
        estheRsvInfo,
        setEstheRsvInfo,
        estheticInfo,
        setPopupMode,
        setPopupData,
        setPopupMessage,
        onClickOpenCalendarWindow,
        onClickOpenPopupWindow,
        onClickClosePopupWindow,
        onClickOpenCoursePopup,
    } = props;
    const store = useStore();
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupTitle = state.popupTitle;
    const popupMode = state.popupMode;
    const [courseNumList, setCourseNumList] = useState([]);
    let dataList = [];
    let popupData = state.popupData;
    let popupDataList = state.popupDataList;
    let footerClass = "";
    const popupRef = useRef(null);
    const [errorInfo, setErrorInfo] = useState({ errorFlg: false, errorMessageBox: [] });
    const [messageInfo, setMessageInfo] = useState({ messageFlg: false, message: [] });


    if (popupMode == 'yoyakuTime') {
        footerClass = "decision"
        dataList = popupData.yoyakuKanoTimeInfoList;
    } else if (popupMode == 'mainCourse') {
        footerClass = "selectYoyakuTime";
        dataList = popupData.courseList;
    } else if (popupMode == 'optionCourse') {
        footerClass = "selectYoyakuTime";
        dataList = popupData.courseList;
    } else if (popupMode == "doiInfo" || popupMode == "serviceInfo") {
        footerClass = "message"
    }
    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);
    useEffect(() => {
        popupRef.current.scrollTop = 0;
        if (popupMode == "mainCourse" || popupMode == "optionCourse") {
            let numList = [];
            // for (let i = 1; i <= 予約人数; i++) {
            for (let i = 0; i <= 1; i++) {
                numList.push({ id: i, value: i });
            }
            setCourseNumList(numList);
        } else if (popupMode == 'serviceInfo') {
            if (document.getElementById("popupText")) {
                let element = document.getElementById("popupText");
                element.innerHTML = CommonUtil.replaceSpecialChar(popupData.serviceInfo.serviceText ? popupData.serviceInfo.serviceText : "");
            }
        }
        if (popupMode == "mainCourse") {
            setMessageInfo({messageFlg: true, message: [MessageConst.ESTHETIC_MENU_MESSAGE]});
        } else if (popupMode == "optionCourse"){
            setMessageInfo({messageFlg: true, message: [MessageConst.ESTHETIC_OPTION_MESSAGE]});
        } else {
            setMessageInfo({messageFlg: false, message: []});
        }
    }, [popupMode]);

    const getPopupText = () => {
        if (popupMode === 'doiInfo') {
            return popupData.doiInfo.text ? popupData.doiInfo.text : ""
        }
    }

    // 利用日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(estheRsvInfo.riyoDate);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();
        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    // 利用日選択カレンダー表示
    const onClickOpenCalendar = () => {
        let riyoDate = CommonUtil.getDateFromString(estheRsvInfo.riyoDate, "-");
        let startDate = new Date(riyoDate);
        startDate.setDate(1);
        startDate.setDate(startDate.getDate() - startDate.getDay());
        let baseDate = new Date();
        baseDate.setDate(baseDate.getDate())
        if ((baseDate.getFullYear() === riyoDate.getFullYear() && baseDate.getMonth() === riyoDate.getMonth()) || baseDate >= startDate) {
            startDate = new Date(baseDate);
        }
        const reqStartDate = CommonUtil.getStringFromDate(startDate,"yyyy-MM-dd");
        let reqReserveInfo = {...estheRsvInfo, riyoDate: reqStartDate};
        onClickOpenCalendarWindow(estheticInfo, reqReserveInfo)
        onClickClosePopupWindow();
    }

    const afterGetCourseInfo = (res, ref) => {
        let errorFlg = false;
        let errorMessageBox = [];
        const data = res.data;
        if (data.resultCode === "0") {
            let courseList = [];
            if (ref.courseType == "mainCourse") {
                courseList = data.courseList.filter(value => value.optionKbn == "1") 
            } else if (ref.courseType == "optionCourse") {
                courseList = data.courseList.filter(value => value.optionKbn == "2") 
            }
            setPopupData({
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                rstEstheCd: estheticInfo.estheticCd,
                courseList: courseList,
                jikantai: popupData.jikantai
            })
            onClickOpenPopupWindow(ref.courseType)
        } else {
            errorFlg = true;
            errorMessageBox.push(data.errorMassage);
        }
        setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
    }

    const afterGetYoyakuKanoTimeInfo = (res, refEstheRsvInfo) => {
        let errorFlg = false;
        let errorMessageBox = [];
        const data = res.data;
        if (data.resultCode === "0") {
            let result = false;
            if (estheRsvInfo.yoyakuTime) {
                const yoyakuKanoTimeInfoList = data.yoyakuKanoTimeInfoList;
                yoyakuKanoTimeInfoList?.forEach(value => {
                    value?.yoyakuKanoTimeList?.forEach(timeValue => {
                        if (timeValue.startTime == estheRsvInfo.yoyakuTime) {
                            result = true;
                            return;
                        }
                    })
                })
            } else {
                result = true;
            }
            if (result) {
                setEstheRsvInfo(refEstheRsvInfo)
                setPopupData({
                    honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                    shisetsuCd: estheticInfo.shisetsuCd,
                    rstEstheCd: estheticInfo.estheticCd,
                    yoyakuKanoTimeInfoList: data.yoyakuKanoTimeInfoList,
                    jikantai: popupData.jikantai
                })
                onClickOpenPopupWindow("yoyakuTime")
            } else {
                setEstheRsvInfo({ ...refEstheRsvInfo, yoyakuTime: "" })
                errorFlg = true;
                errorMessageBox = [MessageConst.ESTHETIC_VACANCY_ERROR]
                popupRef.current.scroll({ top: 0, behavior: 'smooth' });
            }
        }
        setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
    }

    const onClickClose = () => {
        setErrorInfo({errorFlg: false, errorMessageBox: []});
        onClickClosePopupWindow();
    }

    // 決定
    const onClickDecide = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        // 選択した時間のセッション登録↓
        let yoyakuTimeList = document.getElementsByName("yoyakuTime");
        let yoyakuTime = "";
        yoyakuTimeList.forEach(value => {
            if (value.checked) {
                yoyakuTime = value.value;
            }
        });
        if (yoyakuTime == "") {
            errorFlg = true;
            errorMessageBox.push(MessageConst.VALID_INPUT_ERROR);
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        }
        if (!errorFlg) {
            setEstheRsvInfo({...estheRsvInfo, yoyakuTime:yoyakuTime})
            onClickClosePopupWindow();
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }

    // 空き情報チェック処理
    const afterVacancyCheck = (res, ref) => {
        let errorFlg = false;
        let errorMessageBox = [];
        let data = res.data;
        if (data.resultCode == 0) {
            let result = false;
            const yoyakuKanoTimeInfoList = data.yoyakuKanoTimeInfoList;
            yoyakuKanoTimeInfoList?.forEach(value => {
                value?.yoyakuKanoTimeList?.forEach(timeValue => {
                    if (timeValue.startTime == estheRsvInfo.yoyakuTime) {
                        result = true;
                        return;
                    }
                })
            })
            if (result) {
                let newEstheRsvInfo = { ...estheRsvInfo, mainCourseList: ref.refCourseList };
                // setEstheRsvInfo(newEstheRsvInfo);
                onClickCondition("yoyakuTime", ref.reqCourseList, newEstheRsvInfo);
            } else {
                errorFlg = true;
                errorMessageBox = [MessageConst.ESTHETIC_VACANCY_ERROR]
                setEstheRsvInfo({ ...estheRsvInfo, mainCourseList: ref.refCourseList, yoyakuTime: "" })
                popupRef.current.scroll({ top: 0, behavior: 'smooth' });
            }
        } else {
            errorFlg = true;
            errorMessageBox = [data.errorMessage]
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }

    // コース選択ポップアップ、時間選択へボタン
    const onClickToYoyakuTime = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        let riyoNinzuSum = 0;
        let refCourseList = [];
        let reqCourseList = [];
        dataList.forEach((value, index) => {
            let courseNum = Number(document.getElementById(value.courseCd).value);
            if (courseNum > 0) {
                riyoNinzuSum += courseNum;
                refCourseList.push({
                    courseCd: value.courseCd,
                    courseName:value.courseName,
                    tanka: value.tanka,
                    optionKbn: value.optionKbn,
                    hyojunTime: value.hyojunTime,
                    courseNum: courseNum
                })
                reqCourseList.push({courseCd: value.courseCd})
            }
        });

        if (riyoNinzuSum === 1) {
            if (estheRsvInfo.yoyakuTime) {
                // コース確定
                // if (estheRsvInfo?.optionCourseList?.length > 0) {
                //     reqCourseList = reqCourseList.concat(estheRsvInfo.optionCourseList.map(value => {
                //         return {courseCd: value.courseCd};
                //     }));
                // }
                let req = {
                    honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                    shisetsuCd: estheticInfo.shisetsuCd,
                    cornerBunKbn: "2",  /* 固定値 */
                    rstEstheCd: estheticInfo.estheticCd,
                    riyoDate: estheRsvInfo.riyoDate,
                    riyoNinzu: "1",
                    courseList: reqCourseList,
                    importedFlg: true
                }
                const ref = {reqCourseList, refCourseList};
                common.doPostRef(getYoyakuKanoTimeInfo, req, ref, afterVacancyCheck);
            } else {
                let newEstheRsvInfo = { ...estheRsvInfo, mainCourseList: refCourseList };
                // setEstheRsvInfo(newEstheRsvInfo);
                onClickCondition("yoyakuTime", reqCourseList, newEstheRsvInfo);
            }
        } else {
            // エラー処理
            errorFlg = true;
            errorMessageBox = [MessageConst.VALID_INPUT_ERROR]
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }

    // // オプション選択ポップアップ、時間選択へボタン
    // const onClickToYoyakuTime = () => {
    //     // 選択したコースの受け渡し↓
    //     let refCourseList = [];
    //     dataList.forEach((value, index) => {
    //         let riyoNinzu = Number(document.getElementById(value.courseCd).value);
    //         if (riyoNinzu === 1) {
    //             refCourseList.push({ 
    //                 courseCd: value.courseCd,
    //                 courseName:value.courseName,
    //                 tanka: value.tanka,
    //                 optionKbn: value.optionKbn,
    //                 hyojunTime: value.hyojunTime,
    //             });
    //         }
    //     })
    //     let newEstheRsvInfo = { ...estheRsvInfo, optionCourseList: refCourseList };
    //     let reqCourseList = [];
    //     estheRsvInfo.mainCourseList.forEach((value) => {
    //         reqCourseList.push({
    //             courseCd: value.courseCd,
    //             optionKbn: value.optionKbn,
    //             hyojunTime: value.hyojunTime
    //         });
    //     })
    //     refCourseList.forEach((value) => {
    //         reqCourseList.push({
    //             courseCd: value.courseCd,
    //             optionKbn: value.optionKbn,
    //             hyojunTime: value.hyojunTime
    //         });
    //     })
    //     onClickCondition("yoyakuTime", reqCourseList, newEstheRsvInfo);
    // }

    const onClickCondition = (mode, courseList, newEstheRsvInfo) => {
        if (mode === "mainCourse" || mode === "optionCourse"){
            let req = {
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                cornerBunKbn: "2", /* 固定値 */
                rstEstheCd: estheticInfo.estheticCd,
                jikantai: "1",
                riyoDate: estheRsvInfo.riyoDate
            }
            common.doPostRef(getCourseInfo, req, {courseType: mode}, afterGetCourseInfo);
        } else if (mode === "yoyakuTime"){
            // 予約可能時間情報取得
            let req = {
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                cornerBunKbn: "2",  /* 固定値 */
                rstEstheCd: estheticInfo.estheticCd,
                riyoDate: newEstheRsvInfo.riyoDate,
                riyoNinzu: "1",
                courseList: courseList,
                importedFlg: true
            }
            common.doPostRef(getYoyakuKanoTimeInfo, req, newEstheRsvInfo, afterGetYoyakuKanoTimeInfo);
        }
    }

    const onClickRadioForm = (id) => {
        let target = document.getElementById(id);
        target.click();
    }

    const popupBody = dataList ? dataList.map((value, index) => {
        if (popupMode == 'yoyakuTime') {
            if(value.yoyakuKanoTimeList){
                return value.yoyakuKanoTimeList.map((timeValue, timeIndex) => {
                    return <>
                        {timeValue.akiFlg ?
                            <div key={"yoyakuTime" + index + timeIndex} className={errorInfo.errorFlg ? "errorMealTimeRadio2" : "mealTimeRadio2"} onClick={() => onClickRadioForm(timeValue.startTime + "0")} >
                                <RadioButtonForm
                                    id={timeValue.startTime}
                                    data={[{ value: timeValue.startTime, text: CommonUtil.getTimeStr(timeValue.startTime, "hh:mm"), id: timeValue.startTime, checked: estheRsvInfo.yoyakuTime == timeValue.startTime }]}
                                    name="yoyakuTime"
                                    inputClassName="inputRadioButtonGold"
                                    labelClassName="timeRadioButton"
                                />
                            </div>
                            :
                            <div key={"yoyakuTime" + index} className={"mealTimeLabel2"}>
                                <Label
                                    className="mealTimeCross"
                                />
                                <Label
                                    label={CommonUtil.getTimeStr(timeValue.startTime, "hh:mm")}
                                    className="mansekiTimeLabel"
                                />
                            </div>
                        }
                    </>
                })
            }
        } else if (popupMode == "mainCourse") {
            return <>
                {isMobilePhone ?
                    <div key={"mainCourse" + index} className={"courseRow"}>
                        <div className="pullDownCourseNameWrapper">
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.tanka?.toLocaleString() + "（税込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    divClass="coursePullDown2"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum2" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={estheRsvInfo.mainCourseList && estheRsvInfo.mainCourseList.find(course => course.courseCd == value.courseCd) ? 1 : 0}
                                />
                            )
                        }
                    </div>
                    :
                    <div key={"mainCourse" + index} className={"courseRow"}>
                        <div className="pullDownCourseNameWrapper">
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.tanka?.toLocaleString() + "（税込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    divClass="coursePullDown2"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum2" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={estheRsvInfo.mainCourseList && estheRsvInfo.mainCourseList.find(course => course.courseCd == value.courseCd) ? 1 : 0}
                                />
                            )
                        }
                    </div>
                }
            </>
        } else if (popupMode == "optionCourse") {
            return <>
                {isMobilePhone ?
                    <div key={"optionCourse" + index} className={"courseRow"}  >
                        <div className="pullDownCourseNameWrapper">
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.tanka?.toLocaleString() + "（税込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    divClass="coursePullDown2"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum2" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={estheRsvInfo.optionCourseList && estheRsvInfo.optionCourseList.find(course => course.courseCd == value.courseCd) ? 1 : 0}
                                />
                            )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                    :
                    <div key={"optionCourse" + index} className={"courseRow"}  >
                        <div className="pullDownCourseNameWrapper">
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.tanka?.toLocaleString() + "（税込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    divClass="coursePullDown2"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum2" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={estheRsvInfo.optionCourseList && estheRsvInfo.optionCourseList.find(course => course.courseCd == value.courseCd) ? 1 : 0}
                                />
                            )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                }
            </>
        }
    }) : null;

    return (
        <div className={state.membershipPopup ? "popupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={popupMode == "bookConfirm" ? "hiddenItem" : isMobilePhone ? "inputUserPopupInner_media" : "inputUserPopupInner"}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickClose()} />
                <h4 className="popupInnerText" >{popupMode == "doiInfo" ? popupData.doiInfo.title : popupMode == "serviceInfo" ? popupData.serviceInfo.serviceTitle : popupTitle}</h4>
                <div className={messageInfo.messageFlg ? "messageInfoDiv" : "hiddenItem"}>
                    <Label label={messageInfo.message}/>
                </div>
                <div className={errorInfo.errorFlg ? "errorDiv" : "hiddenItem"}>
                    <ErrorMassage data={errorInfo.errorMessageBox} />
                </div>
                <div className={popupMode == "yoyakuTime" ? "radioWrapper" : "popupBodyWrapper"}>
                    {popupMode == "mainCourse" || popupMode == "optionCourse" || popupMode == "yoyakuTime" ?
                        <div className="estheticPopupWrapper">
                            <Label
                                label="利用日"
                                className="estheticCourseLabel"
                            />
                            <div className="importedChangeArea">
                                <Label
                                    label={getDateToString()}
                                    className="estheticChangeLabel"
                                />
                                <Button
                                    buttonText="利用日変更"
                                    className="importedChangeBtn"
                                    onClick={() => onClickOpenCalendar(estheticInfo, estheRsvInfo.riyoDate)}
                                />
                            </div>
                        </div>
                        : null}
                    {popupMode == "optionCourse" || popupMode == "yoyakuTime" ?
                        <div className="estheticPopupWrapper">
                            <Label
                                label="コース" 
                                className="estheticCourseLabel"
                            />
                            <div className="importedChangeArea">
                                <Label
                                    label={estheRsvInfo.mainCourseList?.[0]?.courseName}
                                    className="estheticChangeLabel"
                                />
                                <Button
                                    buttonText="コース変更"
                                    className="importedChangeBtn"
                                    onClick={() => onClickCondition("mainCourse")}
                                />
                            </div>
                        </div>
                        : null}
                    {/* {popupMode == "yoyakuTime" ?
                        <div className="estheticPopupWrapper">
                            <Label
                                label="オプション"
                                className="estheticCourseLabel"
                            />
                            <div className="importedChangeArea">
                                <div>
                                    {estheRsvInfo.optionCourseList && estheRsvInfo.optionCourseList.length > 0 ?
                                        <>
                                            {estheRsvInfo.optionCourseList.map(optionCourse =>
                                                <Label
                                                    label={optionCourse.courseName}
                                                    className="estheticChangeLabel"
                                                />
                                            )}
                                        </>
                                        :
                                        <Label
                                            label={"選択なし"}
                                            className="estheticChangeLabel"
                                        />
                                    }
                                </div>
                                <Button
                                    buttonText="オプション変更"
                                    className="importedChangeBtn"
                                    onClick={() => onClickCondition("optionCourse")}
                                    />
                            </div>
                        </div>
                        : null} */}
                    {popupMode == "serviceInfo" ?
                        <div className="messageClass" >
                            <div id="popupText">
                            </div>
                        </div>
                        :
                        <>
                            {popupMode === "doiInfo" ?
                                <div className="messageClass" >
                                    <div id="popupText">
                                        {getPopupText()}
                                    </div>
                                    {popupData.doiInfo && popupData.doiInfo.link ?
                                        <a href={popupData.doiInfo.link} target="_blank" rel="noopener noreferrer"> {"「" + popupData.doiInfo.title + "」について"} </a>
                                        : null}
                                </div>
                                :
                                <>
                                    {popupBody}
                                </>
                            }
                        </>
                    }
                </div>
                <div className={footerClass == "decision" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="conditionSearch" onClick={onClickDecide} buttonClassName="buttonText" buttonText="決定" />
                </div>
                {/* <div className={footerClass == "selectOption" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="button" onClick={onClickToOption} buttonClassName="buttonText" buttonText="オプション選択へ" />
                </div> */}
                <div className={footerClass == "selectYoyakuTime" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="button" onClick={onClickToYoyakuTime} buttonClassName="buttonText" buttonText="時間選択へ" />
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

// const styles = {
//     popup: {
//         position: "fixed",
//         left: "0",
//         top: "0",
//         width: "100%",
//         height: "100%",
//         zIndex: "9999",
//         opacity: "0",
//         visibility: "hidden",
//         transition: ".6s",
//     },
//     popupIsShow: {
//         position: "fixed",
//         left: "0",
//         top: "0",
//         width: "100%",
//         height: "100%",
//         zIndex: "9999",
//         opacity: "1",
//         visibility: "visible",
//         transition: ".6s",
//     },
// }

const mapStateToProps = (state) => {
    return {
        login: state.login,
        yoyakuTime: state.yoyakuTime,
        course: state.course,
        estheRsvInfo: state.estheRsvInfo,
        estheticInfo: state.estheticInfo,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setEstheRsvInfo: (item) => {
            dispatch({ type: "ESTHE_RSV_INFO", payload: { estheRsvInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(EstheticUserPopupContainer);